import React, { useState, useEffect } from "react";

import { Container } from "react-bootstrap";

import { commentApi } from "../../../utility/api/apiList";

import useAxios from "../../../hooks/useAxios";

import CommentComponent from "../../../components/public/singleSimTabs/comment";

import { TabContentSection } from "../styledSimContainer";

const SimCommentContainer = ({ simID, CheckAccessFunction }) => {
  const [commentsPageSize, setCommentsPageSize] = useState(2);
  const [newComment, setNewComment] = useState({
    title: "",
    content: "",
    sim: simID,
  });

  const {
    isLoaded,
    data: getCommentData,
    error: getCommentsError,
    run: getComments,
  } = useAxios({
    url: commentApi,
    params: {
      filter_sim__id__in: simID,
      order__by: "datetime",
      page_size: commentsPageSize,
      filter_is_verified: "True",
    },
  });

  const { error: postCommentError, run: postComment } = useAxios({
    url: commentApi,
    method: "post",
  });

  useEffect(() => {
    getComments();
  }, [commentsPageSize]);

  let element = null;
  if (getCommentsError) {
    element = (
      <>
        <p className="text-center">{getCommentsError}</p>
        <CommentComponent
          getCommentsError={getCommentsError}
          postCommentFunction={postComment}
        />
      </>
    );
  } else if (getCommentData) {
    element = (
      <CommentComponent
        simID={simID}
        count={isLoaded && !getCommentsError && getCommentData.count}
        commentsList={
          isLoaded && !getCommentsError
            ? getCommentData.results
            : { count: 0, results: new Array(2).fill("") }
        }
        commentPageSizeUseState={[commentsPageSize, setCommentsPageSize]}
        newCommentUseState={[newComment, setNewComment]}
        postCommentFunction={postComment}
        postCommentError={postCommentError}
        CheckAccessFunction={CheckAccessFunction}
      />
    );
  }
  return (
    <TabContentSection className="py-4">
      <Container>
        <h3 className="title text-center">نظرات کاربران</h3>
        {element}
      </Container>
    </TabContentSection>
  );
};

export default SimCommentContainer;
